import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';

interface ColorGuideItem {
  color: string;
  label: string;
}

interface ColorGuideProps {
  items: ColorGuideItem[];
}

const ColorGuide: React.FC<ColorGuideProps> = ({ items }) => {
  const theme = useTheme();

  return (
    <Box sx={{ px: 1, backgroundColor: 'transparent', borderRadius: 1, display: 'flex', justifyContent: 'center', mt: -1, pb: 3 }} >
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
        {items.map((item, index) => (
          <Stack key={index} direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 16,
                height: 16,
                backgroundColor: item.color,
                borderRadius: 0.5,
                border: `1px solid ${theme.palette.divider}`
              }}
            />
            <Typography variant="caption" sx={{ fontSize: '12px' }}>
              {item.label}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export default ColorGuide;
